import { render, staticRenderFns } from "./newPost.vue?vue&type=template&id=0f4ff9da&"
import script from "./newPost.vue?vue&type=script&lang=js&"
export * from "./newPost.vue?vue&type=script&lang=js&"
import style0 from "./newPost.vue?vue&type=style&index=0&id=0f4ff9da&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports